import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  pageSize: storage.session.getItem(types.DASHBOARD_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.DASHBOARD_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.DASHBOARD_SORT_DIR) || 'asc',
  orderBy: storage.session.getItem(types.DASHBOARD_ORDER_BY) || 'firm',
  filterBy: parseInt(storage.local.getItem(types.DASHBOARD_FILTER_BY)) || null,
  firms: JSON.parse(storage.local.getItem(types.DASHBOARD_FIRMS)) || null,
  allFirms: storage.local.getItem(types.DASHBOARD_ALLFIRMS) === 'true' || false,
  filterOptions: [],
  startDate: null,
  endDate: null,
  analyzeView: null,
  analyzeViews: [
    {
      value: 1,
      name: 'by service (counts)',
      type: 'Trends|Breakout'
    },
    {
      value: 2,
      name: 'by service (sales)',
      type: 'Trends|Breakout'
    },
    {
      value: 3,
      name: 'by vehicle make (counts)',
      type: 'Trends|Breakout'
    },
    {
      value: 4,
      name: 'by vehicle make (sales)',
      type: 'Trends|Breakout'
    },
    {
      value: 5,
      name: 'by tech (hours)',
      type: 'Trends|Breakout'
    },
    {
      value: 6,
      name: 'by tech (cost)',
      type: 'Trends|Breakout'
    },
    {
      value: 7,
      name: 'all',
      type: 'All'
    },
    {
      value: 8,
      name: 'single location',
      type: 'Invoicing'
    },
    {
      value: 9,
      name: 'all DASHBOARD',
      type: 'Invoicing'
    }
  ],
  rangeView: null,
  rangeViews: [
    {
      value: 1,
      name: 'yesterday',
      type: 'All'
    },
    {
      value: 2,
      name: 'this week',
      type: 'All'
    },
    {
      value: 3,
      name: 'this month',
      type: 'All'
    },
    {
      value: 4,
      name: 'this qtr',
      type: 'All'
    },
    {
      value: 5,
      name: 'past 6 months',
      type: 'All'
    },
    {
      value: 6,
      name: 'past year',
      type: 'All'
    },
    {
      value: 7,
      name: 'date range',
      type: 'All'
    }
  ],
  dashboard: null,
  dashboardTop: null,
  adasRecords: [],
  evaluation: null,
  failedVins: [],
  counts: null,
  topStats: null,
  clientReview: null,
  clientInspections: [],
  decodeStats: null,
  clientBreakdown: null,
  log: [],
  logParameters: null,
  bms: null,
  fragmentation: [],
  missingIndexes: [],
  aiLoading: false,
  aiResponse: [],
  quote: [],
  predictive: []
})



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/state.js